/* eslint-disable no-param-reassign */
import axios from 'axios'

const baseURL = process.env.VUE_APP_BASE_URL

export default {
   namespaced: true,
   state: {
      tahun: new Date().getFullYear(),
      refreshTimestamp: 0,
      statistik: {
         umk: {
            periode_1: 0,
            periode_2: 0,
         },
         nonumk: {
            periode_1: 0,
            periode_2: 0,
            periode_4: 0,
            periode_5: 0,
         },
      },
      nonUmkChart: {
         data: [],
      },
      nonUmkKbli: {
         data: [],
      },
      nonUmkSektor: {
         data: [],
      },
      nonUmkStatus: {
         data: [],
      },
   },
   actions: {
      triggerRefresh({ commit }) {
         commit('SET_REFRESH_TIMESTAMP', Date.now())
      },
      getStatistik({ commit, rootState, state }, tahun = state.tahun) {
         const selectedYear = tahun instanceof Date
            ? tahun.getFullYear()
            : Number(tahun) || new Date().getFullYear()

         commit('SET_TAHUN', selectedYear)
         rootState.isLoading = true
         return axios.get(`${baseURL}dashboard/lkpm/statistik`, {
            params: { year: selectedYear },
         }).then(
            response => {
               const data = response.data || {}
               commit('SET_STATISTIK', data.data || data || {})

               rootState.isLoading = false
               return data
            },
            () => {
               rootState.isLoading = false
            },
         )
      },
      getNonUmkChart({ commit, rootState, state }, tahun = state.tahun) {
         const selectedYear = tahun instanceof Date
            ? tahun.getFullYear()
            : Number(tahun) || new Date().getFullYear()

         rootState.isLoading = true
         return axios.get(`${baseURL}dashboard/lkpm/non-umk-chart`, {
            params: { year: selectedYear },
         }).then(
            response => {
               const data = response.data || {}
               commit('SET_NON_UMK_CHART', data)

               rootState.isLoading = false
               return data
            },
            error => {
               rootState.isLoading = false
               return Promise.reject(error)
            },
         )
      },
      getNonUmkKbli({ commit, rootState, state }, tahun = state.tahun) {
         const selectedYear = tahun instanceof Date
            ? tahun.getFullYear()
            : Number(tahun) || new Date().getFullYear()

         rootState.isLoading = true
         return axios.get(`${baseURL}dashboard/lkpm/non-umk-kbli`, {
            params: { year: selectedYear },
         }).then(
            response => {
               const data = response.data || {}
               commit('SET_NON_UMK_KBLI', data)

               rootState.isLoading = false
               return data
            },
            error => {
               rootState.isLoading = false
               return Promise.reject(error)
            },
         )
      },
      getNonUmkSektor({ commit, rootState, state }, tahun = state.tahun) {
         const selectedYear = tahun instanceof Date
            ? tahun.getFullYear()
            : Number(tahun) || new Date().getFullYear()

         rootState.isLoading = true
         return axios.get(`${baseURL}dashboard/lkpm/non-umk-sektor`, {
            params: { year: selectedYear },
         }).then(
            response => {
               const data = response.data || {}
               commit('SET_NON_UMK_SEKTOR', data)

               rootState.isLoading = false
               return data
            },
            error => {
               rootState.isLoading = false
               return Promise.reject(error)
            },
         )
      },
      getNonUmkStatus({ commit, rootState, state }, tahun = state.tahun) {
         const selectedYear = tahun instanceof Date
            ? tahun.getFullYear()
            : Number(tahun) || new Date().getFullYear()

         rootState.isLoading = true
         return axios.get(`${baseURL}dashboard/lkpm/non-umk-status`, {
            params: { year: selectedYear },
         }).then(
            response => {
               const data = response.data || {}
               commit('SET_NON_UMK_STATUS', data)

               rootState.isLoading = false
               return data
            },
            error => {
               rootState.isLoading = false
               return Promise.reject(error)
            },
         )
      },
   },
   mutations: {
      SET_TAHUN(state, tahun) {
         state.tahun = tahun
      },
      SET_REFRESH_TIMESTAMP(state, timestamp) {
         state.refreshTimestamp = timestamp
      },
      SET_STATISTIK(state, data) {
         const umk = data.umk || {}
         const nonumk = data.nonumk || {}

         state.statistik = {
            umk: {
               periode_1: Number(umk.periode_1 ?? 0),
               periode_2: Number(umk.periode_2 ?? 0),
            },
            nonumk: {
               periode_1: Number(nonumk.periode_1 ?? 0),
               periode_2: Number(nonumk.periode_2 ?? 0),
               periode_4: Number(nonumk.periode_4 ?? 0),
               periode_5: Number(nonumk.periode_5 ?? 0),
            },
         }
      },
      SET_NON_UMK_CHART(state, data) {
         state.nonUmkChart = {
            data: Array.isArray(data.data) ? data.data : [],
         }
      },
      SET_NON_UMK_KBLI(state, data) {
         state.nonUmkKbli = {
            data: Array.isArray(data.data) ? data.data : [],
         }
      },
      SET_NON_UMK_SEKTOR(state, data) {
         state.nonUmkSektor = {
            data: Array.isArray(data.data) ? data.data : [],
         }
      },
      SET_NON_UMK_STATUS(state, data) {
         state.nonUmkStatus = {
            data: Array.isArray(data.data) ? data.data : [],
         }
      },
   },
}
